module.exports = __webpack_public_path__ + "media/images/flags/32/Cameroon-0292acfd9cde3a89ad9a325b7714d49e.png";